var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector85(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 320,
    viewBox: "0 0 342 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340.556 318.783C316.318 299.181 312.477 294.912 297.124 274.799C293.361 269.872 287.442 260.292 281.789 248.461C280.095 244.92 278.559 241.409 277.151 237.947C267.105 213.172 265.687 185.417 268.021 158.006C273.979 88.0672 236.122 24.9445 178.803 6.54272C121.386 -11.8885 57.627 18.4335 26.5155 65.751C22.4677 71.9078 4.61233 100.961 1.97292 132.837C-6.38848 233.481 91.1021 273.698 239.441 304.148C242.326 304.738 256.065 306.99 258.98 307.393L340.565 318.792L340.556 318.783Z",
    stroke: "#1E1E22",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector85);
export default __webpack_public_path__ + "static/media/vector8-5.74c2fa8334617227790f696482233c45.svg";
export { ForwardRef as ReactComponent };